<app-theme-picker
  title="Desafio Diário"
  [themes]="themes()"
  [isLoading]="isLoadingThemes()"
  (themeSelect)="onThemeClick($event)"
  (back)="onBackClick()"
/>
